'use client';
import React, { useEffect, useState } from 'react';
import styled from '@benzinga/themetron';
import { CoinInput, CoinMarquee } from '@benzinga/crypto';

export interface CoinMarqueeProps {
  innerHTML: string;
}

export const CoinMarqueeBlock: React.FC<CoinMarqueeProps> = ({ innerHTML }) => {
  const [coins, setCoins] = useState<CoinInput[]>([]);

  useEffect(() => {
    if (!innerHTML) return;
    const elem = document.createElement('div');
    elem.innerHTML = innerHTML;
    const coinMarquee = elem.querySelector('#crypto-widget-CoinMarquee');
    const coinsString = coinMarquee?.getAttribute('data-coins') ?? '';
    const coinsArray = coinsString?.split(',') ?? [];
    const coinData = coinsArray.map((slug: string) => {
      return { name: '', slug, symbol: '' };
    });
    setCoins(coinData);
  }, [innerHTML]);

  if (!innerHTML) return null;

  return (
    <Container>
      <CoinMarquee coins={coins} />
    </Container>
  );
};

const Container = styled.div`
  margin: 1rem auto;
  height: 118px;
  @media screen and (max-width: 768px) {
    margin: 0 auto;
  }
`;
